interface Props {
  status: string;
  updatedAt?: string;
}

export default function StatusPill({ status, updatedAt }: Props) {
  const lower = status.toLowerCase();
  const tone =
    lower === "final"
      ? "bg-pit-live/20 text-pit-live border-pit-live/30"
      : "bg-pit-gold/20 text-pit-gold border-pit-gold/30 animate-pulse";

  return (
    <div className="flex items-center gap-2 text-[11px] font-mono">
      <span className={`pill border ${tone}`}>{status}</span>
      {updatedAt && (
        <span className="text-pit-muted">updated {updatedAt}</span>
      )}
    </div>
  );
}
